// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions

import { Product, ProductPriceRanges } from 'graphql-api/gql-api-interfaces';

import { createInstanceWithChildren } from '../../utils/dynamic-items-utils';

export const productHeader = createInstanceWithChildren({
  id: 'product-header',
  contentTypeId: 'dynamic-collections-renderer',
  styles: {
    style: {
      __multiple__: {
        provider: 'id:root',
        property: 'productHeaderStyle',
      },
    },
  },
  data: {
    product: {},
    titleFields: ['masterProductTitle'],
    showWholeSalePrices: {
      provider: 'GlobalStoreProviderService',
      property: {
        paths: 'user.showWholeSalePrices',
      },
    },
    prices: {
      provider: 'self',
      property: 'product',
      transform: function (product: Product) {
        return product.prices;
      }.toString(),
    },
    price: {
      values: [
        {
          provider: 'self',
          property: 'prices',
        },
        {
          provider: 'self',
          property: 'showWholeSalePrices',
        },
      ],
      transform: function ([prices, showWspdPrice]: [
        ProductPriceRanges[],
        boolean,
      ]) {
        prices = prices ?? [];
        const price =
          window.neoclesDynamicFramework.recommendationsPanels.methods.findPrice(
            prices,
          );

        if (!showWspdPrice) {
          return {
            ...price,
            wspd: null,
          };
        } else {
          return price;
        }
      }.toString(),
    },
  },
  children: [
    {
      id: 'product-header-card-title-id',
      contentTypeId: 'atx-product-card-title',
      inputs: {
        product: {
          provider: 'parent',
          property: 'product',
        },
        titleFields: {
          provider: 'parent',
          property: 'titleFields',
        },
      },
    },
    {
      id: 'product-header-style-id',
      contentTypeId: 'atx-product-card-style-id',
      inputs: {
        product: {
          provider: 'parent',
          property: 'product',
        },
        formattedProductId: {
          provider: 'parent',
          property: 'product',
          transform: function (product: {
            attributes: Record<
              string,
              {
                value: string;
              }[]
            >;
          }) {
            return product.attributes.articlenumber[0].value;
          }.toString(),
        },
      },
    },
    {
      id: 'product-header-prices',
      contentTypeId: 'atx-product-prices',
      inputs: {
        prices: {
          provider: 'parent',
          property: 'price',
        },
        showWholeSalePrices: {
          provider: 'parent',
          property: 'showWholeSalePrices',
        },
      },
    },
  ],
});
